import React from 'react';

const FloatingShapes = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full -z-10 opacity-60 pointer-events-none">
      <div className="absolute w-full h-full">
        {/* Shape 1 */}
        {/* <div 
          className="absolute w-20 h-20 rounded-full bg-gradient-to-r from-primary-purple to-accent-gold animate-float"
          style={{ top: '20%', left: '10%', animationDelay: '0s' }}
        /> */}
        
        {/* Shape 2 */}
        {/* <div 
          className="absolute w-32 h-32 rounded-full bg-gradient-to-r from-primary-purple to-accent-gold animate-float"
          style={{ top: '60%', right: '10%', animationDelay: '2s' }}
        /> */}
        
        {/* Shape 3 */}
        {/* <div 
          className="absolute w-16 h-16 rounded-full bg-gradient-to-r from-primary-purple to-accent-gold animate-float"
          style={{ bottom: '20%', left: '20%', animationDelay: '4s' }}
        /> */}
        
        {/* Shape 4 */}
        {/* <div 
          className="absolute w-24 h-24 rounded-full bg-gradient-to-r from-primary-purple to-accent-gold animate-float"
          style={{ top: '40%', right: '30%', animationDelay: '3s' }}
        /> */}
      </div>
    </div>
  );
};

export default FloatingShapes;
